import React, { useEffect, useState } from "react";
import SEO from "./SEO";

const Terms = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/terms.html")
      .then(res => res.text())
      .then(setContent);
  }, []);

  return (
    <div className="mt-24 px-10 max-w-5xl mx-auto">
      <SEO
        title="Terms of Use | Schooglink"
        description="Terms of Use for Schooglink and Pathyacharya learning platform."
        url="https://schooglink.com/terms"
      />
      <h1 className="text-4xl text-center mb-6">TERMS OF USE</h1>
      <div
        className="prose max-w-none"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default Terms;
